import React, { useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import classNames from "classnames";
import ButtonIcon from "../common/ButtonIcon";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import FullPagination from "../common/pagination/FullPagination";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import SelectPropertyListItem from "../common/SelectPropertyListItem";
import { PreloadState } from "../UI/preloading/PreloadState";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateAliquotForm = ({
  handleSubmitData,
  handler,
  properties,
  setRedirect,
  setRedirectUrl,
  aliquot,
}) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();

  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting },
    setValue,
    setError,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const { nextPage, previousPage, perPage, goToPage, meta } = handler;
  const [collapseOne, collapseOneOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [amount, setAmount] = useState(null);

  register("value");
  register("property_id");
  register("description");

  useEffect(() => {
    setValue("value", amount);
    if (aliquot) {
      register("value");
      setValue("value", amount);
    }
    if (!amount || Number(amount) <= 0) {
      setError("value", {
        message: "Ingrese un monto válido.",
      });
    } else {
      clearErrors("value");
    }
    // eslint-disable-next-line
  }, [amount]);

  useEffect(() => {
    setValue("property_id", selectedProperty);
    // eslint-disable-next-line
  }, [selectedProperty]);

  useEffect(() => {
    if (aliquot) {
      setSelectedProperty(aliquot.property?.id);
      setAmount(aliquot.value);
    }
    // eslint-disable-next-line
  }, []);

  const renderPropertiesItems = () =>
    properties.map((property) => (
      <SelectPropertyListItem
        key={property.id}
        onSelect={setSelectedProperty}
        selected={selectedProperty}
        propertyId={property?.id}
        name={`${property?.user?.data?.firstname} ${property?.user?.data?.lastname}`}
        username={property?.user?.username}
        dni={property?.user?.data?.dni}
        alternativeName="propietario"
      />
    ));

  return (
    <>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-light"
        onSubmit={handleSubmit(handleSubmitData)}
      >
        <PreloadState loading={isSubmitting} message="Asignando alícuota...">
          <FalconCardHeader title="Asignar alícuota" light={false} />
          <CardBody>
            <Row form>
              <Col sm>
                <Label>Seleccione un propietario de la lista</Label>
                {renderPropertiesItems()}
                <FullPagination
                  nextPage={nextPage}
                  prevPage={previousPage}
                  goToPage={goToPage}
                  meta={meta}
                  className={"shadow-none"}
                  posText={"propietario"}
                  perPage={perPage}
                />
                {!selectedProperty && (
                  <span
                    className={classNames(
                      "text-danger d-inline-block fs--1 font-weight-normal d-block"
                    )}
                  >
                    Debes seleccionar un propietario
                  </span>
                )}
              </Col>
            </Row>
            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="acronym">Porcentaje</Label>
                <NumberFormat
                  prefix="% "
                  decimalScale={7}
                  allowNegative={false}
                  className={`${
                    errors["value"]?.message ? "border danger" : ""
                  } form-control`}
                  defaultValue={aliquot?.value}
                  placeholder="Monto"
                  onValueChange={({ value }) => {
                    setAmount(value);
                  }}
                  thousandSeparator={true}
                  renderText={(value, props) => <div {...props}>{value}</div>}
                />
                <WizardError
                  error={errors["value"]?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
            </Row>
          </CardBody>
          <CardFooter className={classNames("px-md-6 bg-light d-flex")}>
            <ButtonIcon
              color="falcon-default"
              className="ml-auto px-5 mr-2"
              icon={faUndo}
              onClick={() => {
                setRedirectUrl(`/dashboard/${moduleBase}/${id}/aliquots`);
                setRedirect(true);
              }}
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Volver
            </ButtonIcon>
            <ButtonIcon
              color="primary"
              className="px-5"
              onClick={() => collapseOneOpen(!collapseOne)}
              icon="save"
              disabled={!selectedProperty && Object.keys(errors).length > 0}
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Guardar
            </ButtonIcon>
          </CardFooter>
          <Modal isOpen={collapseOne} data-testid="modal">
            <ModalHeader>Confirmación</ModalHeader>
            <ModalBody>
              <p className="mb-0 font-weight-bold fs--1">
                ¿Está seguro de que ingresó todos los datos correctamente? Esta
                información no puede ser cambiada posteriormente.
              </p>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => collapseOneOpen(!collapseOne)}>
                Cancelar
              </Button>
              <Button
                data-testid="submit-button"
                color="primary"
                type="submit"
                disabled={Object.keys(errors).length > 0}
                onClick={handleSubmit(handleSubmitData)}
              >
                Sí, registrar
              </Button>
            </ModalFooter>
          </Modal>
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreateAliquotForm);
